import type { SocialProvider } from 'analytics';

export type SocialAuthResult = 'signup' | 'login' | 'connect';

export interface SocialAuthReturn {
  provider: SocialProvider;
  result: SocialAuthResult;
}

const PROVIDERS: Record<string, SocialProvider> = {
  'google-oauth2': 'google',
  facebook: 'facebook',
};

const RESULTS: SocialAuthResult[] = ['signup', 'login', 'connect'];

export const toSocialProvider = (backend: string | undefined): SocialProvider | undefined =>
  PROVIDERS[backend ?? ''];

// Removes the params so a refresh does not count the same sign-in twice.
export const takeSocialAuthReturn = (): SocialAuthReturn | null => {
  const url = new URL(window.location.href);
  const backend = url.searchParams.get('social_auth');
  const result = url.searchParams.get('social_auth_result') as SocialAuthResult | null;
  if (backend === null && result === null) {
    return null;
  }

  url.searchParams.delete('social_auth');
  url.searchParams.delete('social_auth_result');
  // Runs at module load, so a refused replaceState must not stop the app from starting.
  try {
    window.history.replaceState(window.history.state, '', url.toString());
  } catch {
    // The URL keeps the params; a refresh then counts the sign-in again.
  }

  const provider = toSocialProvider(backend ?? undefined);
  return provider && RESULTS.includes(result) ? { provider, result } : null;
};
